import { SUBSCRIPTION_STATUS, CONNECTION_STATUS } from "../../../container/QBO_Accounting/constants";


const SUBSCRIPTION_CHIP_MAP = {
  [SUBSCRIPTION_STATUS.ACTIVE]: "active",
  [SUBSCRIPTION_STATUS.PLAN_SELECTED]: "pending",
  [SUBSCRIPTION_STATUS.PENDING]: "pending",
  [SUBSCRIPTION_STATUS.AUTH_COMPLETE]: "pending",
  [SUBSCRIPTION_STATUS.CANCELLATION_PENDING]: "pending",
  [SUBSCRIPTION_STATUS.CANCELLED]: "inactive",
};

export const getSubscriptionChipVariant = (status) => {
  return SUBSCRIPTION_CHIP_MAP[status] || "inactive";
};

export const getPlanDisplayText = (billingFrequency, translate) => {
  const key = billingFrequency === "Yearly" ? "planYearly" : "planMonthly";
  return translate(key);
};

export const formatDate = (dateString, lang) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const helper = {
  CONNECTION_STATUS,
  SUBSCRIPTION_STATUS,
  getSubscriptionChipVariant,
  getPlanDisplayText,
  formatDate,
};

export default helper;

